const handleApiError = async (response) => {
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('currentUser');
          window.location.reload();
          throw new Error('Oturum süresi doldu veya yetkiniz yok.');
        }
        const errorData = await response.json();
        throw new Error(errorData.message || 'Hata oluştu');
      }
    };

    export const addMeterReading = async (readingData) => {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/meter-readings`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(readingData),
      });
      await handleApiError(response);
      return response.json();
    };

    export const fetchMeterReadings = async (buildingId) => {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/meter-readings?buildingId=${buildingId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });
      await handleApiError(response);
      return response.json();
    };

    export const updateMeterReading = async (readingId, readingData) => {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/meter-readings/${readingId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(readingData),
      });
      await handleApiError(response);
      return response.json();
    };

    export const deleteMeterReading = async (readingId, buildingId) => {
      if (!readingId) {
        throw new Error('Sayaç okuma ID\'si gereklidir');
      }
      
      // URL'ye buildingId parametresini ekleyelim
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/meter-readings/${readingId}?buildingId=${buildingId}`;
      
      console.log('Silme isteği gönderiliyor:', url);
      
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });
      await handleApiError(response);
      return response.json();
    };
